import { useEffect, useMemo, useState } from "react";
import { IndividualSummary } from "../";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { carouselTimeout, carouselTransitionTime } from "../../helpers";
import axios from "../../app/api/axios";

const RECENTLY_EDITED_INDIVIDUALS_URL = "/recentlyEditedIndividuals";
const FEATURED_INDIVIDUALS_LIMIT = 9;
const INDIVIDUALS_PER_SLIDE = 3;

const FeaturedIndividuals = () => {
  const [featuredIndividuals, setFeaturedIndividuals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const getFeaturedIndividuals = async () => {
      try {
        setHasError(false);
        const { data } = await axios.get(
          `${RECENTLY_EDITED_INDIVIDUALS_URL}?limit=${FEATURED_INDIVIDUALS_LIMIT}`
        );

        const recentIndividuals = Array.isArray(data)
          ? data
          : data?.individuals || data?.results || [];

        const recentNames = recentIndividuals
          .map((individual) => individual?.name)
          .filter(Boolean)
          .slice(0, FEATURED_INDIVIDUALS_LIMIT);

        if (isMounted) {
          setFeaturedIndividuals(recentNames);
        }
      } catch (err) {
        if (isMounted) {
          setHasError(true);
          setFeaturedIndividuals([]);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    getFeaturedIndividuals();

    return () => {
      isMounted = false;
    };
  }, []);

  const featuredSlides = useMemo(() => {
    const slides = [];

    for (let index = 0; index < featuredIndividuals.length; index += INDIVIDUALS_PER_SLIDE) {
      slides.push(featuredIndividuals.slice(index, index + INDIVIDUALS_PER_SLIDE));
    }

    return slides;
  }, [featuredIndividuals]);

  return (
    <div className="featured-individuals">
      <h1>Latest Social Sentinel Contributions</h1>
      <hr />
      <div className="featured-individuals-content">
        {isLoading && (
          <p className="featured-individuals-status">Loading featured individuals...</p>
        )}
        {!isLoading && hasError && (
          <p className="featured-individuals-status">
            Unable to load recently edited individuals right now.
          </p>
        )}
        {!isLoading && !hasError && featuredSlides.length === 0 && (
          <p className="featured-individuals-status">
            No recently edited individuals are available yet.
          </p>
        )}
        {!isLoading && !hasError && featuredSlides.length > 0 && (
          <Carousel
            autoPlay={true}
            infiniteLoop={true}
            interval={carouselTimeout}
            showThumbs={false}
            transitionTime={carouselTransitionTime}
            showIndicators={false}
          >
            {featuredSlides.map((slideIndividuals, slideIndex) => (
              <div
                className="individuals-summary-container"
                key={`slide-${slideIndex}`}
              >
                {slideIndividuals.map((name, individualIndex) => (
                  <IndividualSummary
                    key={`${name}-${slideIndex}-${individualIndex}`}
                    name={name}
                  />
                ))}
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default FeaturedIndividuals;
